const PaymentTypeEnum = {
  Payment: {
    id: 1,
    key: "1",
    name: "Payment",
  },
  Refund: {
    id: 2,
    key: "2",
    name: "Refund",
  },
  Deposit: {
    id: 3,
    key: "3",
    name: "Deposit",
  },
};

export default PaymentTypeEnum;
